module.exports = __webpack_public_path__ + "static/img/edit-pen.1a435f94.svg";